import React from 'react';
import './EmptyPage.css';
import BrandFooter from '../components/BrandFooter';

/**
 * Shown when there is no active session (or while the app is still
 * bootstrapping). Same coral gradient as Landing so transitions are
 * seamless — just no hero and no Start button.
 */
const EmptyPage = () => (
  <div className="empty-container">
    <BrandFooter />
  </div>
);

export default EmptyPage;
